(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[533],{

/***/ 1921:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submissions/blind_review",
      function () {
        return __webpack_require__(2038);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ blind_review; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/submissions/blind_review/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n margin: 1vh 3vw 2vh 2vw;\n\n @media (max-width: 426px) {\n  padding: 2vh 5vw 3vh 4vw;\n }\n\n h2 {\n  color: #f70;\n }\n\n > p {\n  text-indent: 2em;\n  margin-top: 0.5vh;\n }\n\n ol {\n  margin-top: 2vh;\n  margin-left: 1vw;\n\n  li {\n   p {\n    display: inline;\n   }\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc95f89-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/pages/submissions/blind_review/index.tsx



var description = 'Instru\xe7\xf5es sobre como adequar seu artigo ao modelo de avalia\xe7\xe3o por pares cega, adotada pela revista.';
var title = 'Avalia\xe7\xe3o por Pares Cega';
var BlindReview = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Assegurando a Avalia\xe7\xe3o por Pares Cega"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Para assegurar a integridade da avalia\xe7\xe3o por pares cega, para submiss\xf5es \xe0 revista, deve-se tomar todos os cuidados poss\xedveis para n\xe3o revelar a identidade de autores e avaliadores entre os mesmos durante o processo. Isto exige que autores, editores e avaliadores (pass\xedveis de enviar documentos para o sistema, como parte do processo de avalia\xe7\xe3o) tomem algumas precau\xe7\xf5es com o texto e as propriedades do documento:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Os autores do documento exclu\xedram do texto nomes, substituindo com \"Autor\" e o ano em refer\xeancias e notas de rodap\xe9, em vez de nomes de autores, t\xedtulo do artigo, etc."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Em documentos do Microsoft Office, a identifica\xe7\xe3o do autor deve ser removida das propriedades do documento (no menu Arquivo ",
                                        '>',
                                        " Propriedades), iniciando em Arquivo, no menu principal, e clicando na sequ\xeancia: Arquivo ",
                                        '>',
                                        ' ',
                                        "Salvar como... ",
                                        '>',
                                        " Ferramentas (ou Op\xe7\xf5es no Mac) ",
                                        '>',
                                        " Op\xe7\xf5es de seguran\xe7a... ",
                                        '>',
                                        " Remover informa\xe7\xf5es pessoais do arquivo ao salvar ",
                                        '>',
                                        " OK ",
                                        '>',
                                        " Salvar."
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var blind_review = (BlindReview);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(1921); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);